import { ReactNode, useContext, useEffect, useState } from "react";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import NumberItem from "../NumberItem";

interface NumberPropsInterface {
  value: { count: number };
  title: string;
  id: string;
  clickable: boolean;
  scale: number;
  headerRight?: ReactNode;
}

const NumberProps = ({
  value,
  title,
  id,
  clickable,
  scale,
  headerRight,
}: NumberPropsInterface) => {
  const { getSizesComponent } = useContext(DashboardContext);
  const [fontSizeNumber, setFontSizeNumber] = useState<{
    sizes: { height: number; width: number };
    scale: number;
  }>({ sizes: { height: 10, width: 10 }, scale: 8 });

  useEffect(() => {
    const sizes = getSizesComponent({ id });
    setFontSizeNumber({ sizes: sizes, scale: scale });
  }, [id, scale, getSizesComponent]);

  return (
    <NumberItem
      title={title}
      number={value.count}
      fontSize={fontSizeNumber}
      clickable={clickable}
      id={id}
      headerRight={headerRight}
    />
  );
};

export default NumberProps;
